const CarotekColors = {
    white: "#fff",
    white2: "#f1f1f2",
    white3: "#cfcfdd",
    white4: "#fcf4f2",
    white5: "#f9c9bf",
    white6: "#fff6c5",
    grey1: "#ccc",
    grey2: "#999",
    grey3: "#e1e1e1",
    grey4: "#a2a2a2",
    grey5: "#e6e6e6",
    grey6: "#fbfbfb",
    grey7: "#bbb",
    grey8: "#f6f6f6",
    grey9: "#696969",
    grey10: "#ddd",
    grey11: "#d5d5d5",
    grey12: "#e0e0e0",
    grey13: "#8a8a8a",
    grey14: "#dfdfe5",
    grey15: "#7d7e81",
    grey16: "#555",
    grey17: "#f9f9f9",
    grey18: "#dcdcdc",
    grey19: "#dedede",
    grey20: "#aeaeae",
    grey21: "#e4e4ed",
    black0: "#000",
    black1: "#222",
    black2: "#252525",
    blue1: "#06c",
    blue2: "#1f68b3",
    blue3: "#0082c6",
    blue4: "#005cb9",
    blue5: "#00aeef",
    red1: "#FF0000",
    red2: "#c60f13",
    red3: "#c20",
    yellow: "#ffd800",
};

export default CarotekColors;
